import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
 
import "./assets/styles/main.css";
// import "./assets/styles/dark.css";
import "./assets/styles/responsive.css";

import Loader from "./components/Loader";
import ImergeyWebsite from "./pages/home/Index";

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter>      
        <RouterChangeHandler />
        <AppRoutes />
        <ToastContainer />
      </BrowserRouter>
    </Suspense>
  );
}

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ImergeyWebsite />} /> 
    </Routes>
  );
};

const RouterChangeHandler = React.memo(() => {
  const location = useLocation();
  const modeSet = localStorage.getItem("theme");
  console.log(modeSet,"ruchika");
  useEffect(() => {
    console.log(modeSet)
    const darkMode = localStorage.getItem("theme") === "dark";
    const existingLink = document.getElementById("theme-style");
    if (existingLink) existingLink.remove();
    const link = document.createElement("link");
    link.id = "theme-style";
    link.rel = "stylesheet";
    link.href = darkMode ? "/main.css" : "/dark.css";
    document.head.appendChild(link);
    localStorage.setItem("theme", darkMode ? "dark" : "main");

    return () => link.remove();
  }, [modeSet]);
  return null;
});

export default App;
